const separators = ['+', ' ', '(', ')', '-', '_', '.'];

export const normalizePhoneNumber = (
  phoneNumber: string | null | undefined,
  countryCode: number | false = 1,
) => {
  if (typeof phoneNumber !== 'string') {
    return '';
  }

  let number = phoneNumber;

  separators.forEach((separator) => {
    number = number.split(separator).join('');
  });

  const requiredLength = 10 + (countryCode === false ? 0 : String(countryCode).length);

  if (number.length < requiredLength) {
    return '';
  }

  if (countryCode === false) {
    return number;
  }

  return number.startsWith(String(countryCode)) ? `+${number}` : `+${countryCode}${number}`;
};

export const phoneValidator = (value?: string) => {
  const normalized = normalizePhoneNumber(value);

  return normalized.length > 10;
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[2]}) ${match[3]}-${match[4]}`;
  }
  return phoneNumber;
};
